import { Link } from 'react-router-dom';

import { LinkButton } from '@/components/ui';
import { paths } from '@/routes/paths';

export function NotFoundPage() {
  return (
    <section className="app-container py-24 text-center">
      <p className="text-brand-600 text-sm font-semibold">404</p>
      <h1 className="text-title text-ink mt-2 font-semibold">Page not found</h1>
      <p className="text-ink-muted mt-2">
        The page you are looking for does not exist or has moved.
      </p>
      <div className="mt-8 flex justify-center gap-3">
        <LinkButton to={paths.home}>Back to home</LinkButton>
        <LinkButton to={paths.internships} variant="secondary">
          Browse internships
        </LinkButton>
      </div>
      <p className="text-ink-muted mt-6 text-sm">
        Need help?{' '}
        <Link to={`${paths.home}#contact`} className="underline">
          Contact us
        </Link>
      </p>
    </section>
  );
}
